import DashboardLayout from "@pma/app/dashboard/layout"
import { AnalyticsDashboard } from "@components/analytics/analytics-dashboard"

const AnalyticsPage = () => {
  return (
    <DashboardLayout>
      <AnalyticsDashboard />
    </DashboardLayout>
  )
}

export default AnalyticsPage
